module.exports = __webpack_public_path__ + "img/Feria_del_Trabajo_2024_Banner.1b239011.jpg";